import { render, staticRenderFns } from "./PartnerLinkChip.vue?vue&type=template&id=dc9cf584&scoped=true"
import script from "./PartnerLinkChip.vue?vue&type=script&lang=js"
export * from "./PartnerLinkChip.vue?vue&type=script&lang=js"
import style0 from "./PartnerLinkChip.vue?vue&type=style&index=0&id=dc9cf584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9cf584",
  null
  
)

export default component.exports